var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.249H20M10 16.249H10.0112M16.25 21.249H10M20 21.249H19.9888M22.5 2.49902V4.99902M7.5 2.49902V4.99902M3.75 9.99902H26.25M3.125 15.3028C3.125 9.85652 3.125 7.13277 4.69 5.44027C6.255 3.74902 8.775 3.74902 13.8125 3.74902H16.1875C21.225 3.74902 23.745 3.74902 25.31 5.44152C26.875 7.13277 26.875 9.85652 26.875 15.304V15.9453C26.875 21.3915 26.875 24.1153 25.31 25.8078C23.745 27.499 21.225 27.499 16.1875 27.499H13.8125C8.775 27.499 6.255 27.499 4.69 25.8065C3.125 24.1153 3.125 21.3915 3.125 15.944V15.3028Z",
    stroke: "#1E1F24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.1a152ccce112474314c2528c0da343bc.svg";
export { ForwardRef as ReactComponent };